import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AttachFilesContractWidget from '../../../widgets/attachfiles/AttachFilesContractWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getContractAttachment, getContractSubmitForm } from '../../../redux/actions/contract'
import CenterOfferAuthorizedSignatoryStaffPanel from '../../../widgets/centerOfferAuthorizedSignatoryStaff/CenterOfferAuthorizedSignatoryStaffPanel'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import { getProposeConsiderApproveProjectFileList } from '../../../redux/actions/proposeConsiderApproveProject'
import ProposeConsiderApproveProjectUploadWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectUploadWidget'

export default function CenterCheckContractAttachments() {
  //ขั้นที่ 2 ตรวจสอบสัญญาและไฟล์แนบ
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [contractSubmitFormSchema, setContractSubmitFormSchema] = useState()
  const [schemaApprovalFile, setSchemaApprovalFile] = useState()

  useEffect(() => {
    projectId && handleGetSchema(projectId)
    projectId && handleContractSubmitForm(projectId)
    projectId && handleGetApprovalFileSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getContractAttachment(projectVersionId)
      // console.log('response => ', response)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetApprovalFileSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProposeConsiderApproveProjectFileList(proposalId)
      setSchemaApprovalFile(_schema)
    } catch (e) {
      console.log(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleContractSubmitForm = async (projectVersionId) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getContractSubmitForm(projectVersionId)
      // console.log('response ', response.model.forms.contractFile)
      setContractSubmitFormSchema(response.model.forms.contractFile)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    // doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            {contractSubmitFormSchema && (
              <>
                <AttachFilesContractWidget
                  schema={contractSubmitFormSchema}
                  isContractFile={true}
                  isShowButtonMakeContract={true}
                />
              </>
            )}

            {schemaApprovalFile?.forms?.uploadDocuments &&
              schemaApprovalFile?.forms?.isShowFile && (
                <>
                  <ProposeConsiderApproveProjectUploadWidget
                    showCommandButton={!schemaApprovalFile?.forms?.disabled}
                    schema={schemaApprovalFile?.forms?.uploadDocuments}
                  />
                  <br />
                </>
              )}

            {schema?.forms?.attachmentGrantee && (
              <>
                <AttachFilesContractWidget
                  schema={schema.forms.attachmentGrantee}
                  isContractCenter={true}
                />
              </>
            )}

            {schema.forms?.contractorList &&
              schema.forms?.contractorList?.contractorList?.length > 0 && (
                <ContractSigningWidgets
                  schema={schema.forms?.contractorList}
                  isBookbank={true}
                  isShowCoiBox={true}
                />
              )}

            {schema?.forms?.requestDocument && (
              <CenterOfferAuthorizedSignatoryStaffPanel
                showCommandButton={!schema.forms.requestDocument.disabled}
                schema={schema.forms.requestDocument}
                isRequestMore={true}
                // contractFileType={contractFileType}
              />
            )}

            {schema?.forms?.requestNote?.note && (
              <CenterOfferAuthorizedSignatoryStaffPanel
                showCommandButton={!schema.forms.requestNote.disabled}
                schema={schema.forms.requestNote}
                isUncetified={true}
              />
            )}
          </>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}

const contractFileType = {
  name: 'contractFileType',
  label: 'เลือกประเภทเอกสารเพิ่มเติม',
  optionSelected: [],
  options: [
    {
      disabled: false,
      label: 'ใบภาษีมูลค่าเพิ่ม',
      value: '0F6A0F9B-F8B1-4046-A656-89D8801F714C',
    },
    {
      disabled: false,
      label: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
      value: '27DE34FC-D460-46BB-9055-F706DCE89859',
    },
    {
      disabled: false,
      label: 'สำเนาบัญชีธนาคาร',
      value: '90BC6EA0-18E9-4FD7-8AC0-05545ECDB21E',
    },
    {
      disabled: false,
      label: 'เอกสารแสดงการจดทะเบียนตราของนิติบุคคล',
      value: 'A8B8C757-0B0D-4C21-834A-1D10782440AE',
    },
    {
      disabled: false,
      label: 'หนังสือมอบอำนาจ',
      value: 'DD3A199D-F45D-48F5-9697-12BF403D3190',
    },
    {
      disabled: false,
      label: 'ใบสำคัญแสดงการจดทะเบียนห้างหุ้นส่วนบริษัท',
      value: 'F91ED32C-44C9-4680-B261-E7AAE7636255',
    },
  ],
  validators: [
    {
      type: 'REQUIRED',
      value: null,
      errorMessage: 'กรุณาเลือก ประเภทเอกสารเพิ่มเติมอย่างน้อย 1 ประเภท',
    },
  ],
}
